<template>
  <div class="card container-fluid">
    <div class="card-header pb-0">
      <h6>{{ tableName }} <span v-if="this.count != 0">({{ count }})</span> на сумму <span v-if="this.summ != 0">{{ summ }}</span> </h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
          <tr>
            <th
                v-for="column in columns"
                :key="column"
                class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text"
            >{{ column }}
            </th>
            <th class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7 header-text">События | Документы</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in data" :key="item.id" :class="getRowClass(item)" style="font-size: 12px !important;">
            <td v-for="([key, value]) in Object.entries(item).filter(([k]) =>

             k !== 'paymentAmount'
             && k !== 'discount'
             && k !== 'oplacheno'
             && k !== 'endPrice'
             && k !== 'sborka'
             && k !== 'ustanovka'
             && k !== 'delivery'
             && k !== 'timeRentStart'

             && k !== 'description'
             && k !== 'complectation'
             && k !== 'equipmentCost'
             && k !== 'bron'
             && k !== 'client'
             && k !== 'blackList'
             && k !=='activeBron'
             && k !== 'active'
             )"
                :key="key">
              <div v-if="key === 'image'" class="d-flex px-2 py-1">
                <div>
                  <img :src="value" class="avatar avatar-sm me-3" :alt="item.name"/>
                </div>
              </div>
              <div v-else-if="key == 'legalData' && item.isLegalEntity && value !== null">
                <button style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                        @click="showDetails(value, item.fullName, key)">Подробнее
                </button>
              </div>
              <div v-else-if="key == 'personalData' && value !== null">
                <button style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                        @click="showDetails(value, item.fullName, key)">Подробнее
                </button>
              </div>
              <div v-else-if="key == 'orders' && value.length !== null">
                <button v-if="value.length > 0"
                        @click="showClientOrders(value, item)"
                        style="margin-bottom: 7px;" class="btn btn-success btn-sm">Подробнее
                </button>
              </div>

              <div v-else-if="key == 'orderItems' && value !== null">
                <button v-if="isArenda" style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                        @click="showProductsInOrder(item)">
                  Подробнее
                </button>
                <button v-else style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                        @click="showProductsInSales(item)">
                  Подробнее
                </button>
              </div>

              <div v-else-if="key == 'serialNumber'">
                <button style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                        @click="showProductAdditionalInfo(item)">
                  Подробнее
                </button>
              </div>

              <div v-else-if="typeof value === 'boolean'">
                <CustomCheckBox :value="value"/>
              </div>
              <div v-else-if="key === 'birthdate'">
                {{ new Date(value).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'}) }}
              </div>
              <div v-else-if="key === 'rentEndDate'">
                {{ new Date(value).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'}) }}
              </div>
              <div v-else-if="key === 'rentStartDate' ">
                {{ new Date(value).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'}) }} <b>{{ item.timeRentStart }}</b>
              </div>
              <div v-else-if="key === 'repairDate' ">
                {{ new Date(value).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'}) }}
              </div>
              <div v-else-if="key === 'clientId'" @click="showEditModal(value)" style="cursor: pointer;">
                {{ getClientNameById(value) }}
              </div>
              <div v-else-if="key === 'clientStatus'">
                <CustomCheckBox :value="getClientEntityById(value)"/>
              </div>
              <div v-else-if="key === 'qty'">
                {{ value }}
              </div>
              <div v-else-if="key === 'dostupno'">
                {{ item.dostupno }}
              </div>
              <div
                  v-else-if="key === 'rentCost' || key === 'oplacheno' || key === 'paymentAmount' || key === 'endPrice' || key === 'delivery' || key === 'securityDepositAmount' || key === 'sborka' || key === 'ustanovka'">
                {{ Number(value).toFixed(2) }} BYN
              </div>
              <div v-else-if="key === 'status'">
                {{ getStatusNameById(value) }}
              </div>
              <div v-else-if="key === 'dolg'" :class="getItemClass(value)">
                {{value}}
              </div>
              <div v-else-if="key === 'discount'">
                {{ value }}%
              </div>
              <div
                  v-else-if="key !== 'legalData'
              && key !== 'personalData'
              && key !== 'bron'
              && key !== 'active'
               ">
                {{ value }}
              </div>
            </td>
            <td v-if="item.client">{{ item.client.fullName }}</td>
            <td v-if="item.client">{{ item.client.personalData.phone }}</td>
            <td class="align-middle">
              <a v-if="availableEdit" href="javascript:;" @click="editAction(item)">
                <i class="fas fa-edit text-primary"></i>
              </a>
              <a v-if="!isRepair" style="margin-left: 15px" href="javascript:;" @click="confirmDelete(item)">
                <i class="fas fa-trash "></i>
              </a>
              <button v-else style="margin-bottom: 7px;" class="btn btn-success btn-sm"
                      @click="confirmDelete(item)">Снять с ремонта
              </button>
              <a v-if="isBlock && item.blackList == null" style="margin-left: 15px" href="javascript:;" @click="blockClient(item.id)">
                <i class="fas fa-ban text-warning"></i>
              </a>
              <b style="margin-left: 15px"> | </b>
              <a v-if="isDoc" style="margin-left: 15px" href="javascript:;" @click="saveLegalContract(item.id)">
                <i class="fas fa-print "></i>
              </a>
              <a v-if="isDoc" style="margin-left: 15px" href="javascript:;" @click="getActPriemPeredach(item.id)">
                <i class="fas fa-file "></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ClientPersonalInfo v-if="showPersonalModal"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ClientLegalInfo v-if="showLegalModal"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ProductsInOrder v-if="showProductsModal"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ProductsInSale v-if="showProductsInSale"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ClientOrdersStatistic v-if="clientOrdersStatisticModal"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ShowProductAdditionalInfo v-if="productAdditionalInfoModal"/>
  </transition>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <ClientCreateModal :updateClients="updateClients"/>
  </transition>
</template>

<script>

import CustomCheckBox from "./CustomCheckBox.vue";
import ClientPersonalInfo from "./ClientsAdditionalInfo/ClientPersonalnfo.vue";
import ClientLegalInfo from "./ClientsAdditionalInfo/ClientLegalInfo.vue";
import velocity from 'velocity-animate'
import ProductsInOrder from "./OrderComponents/ProductsInOrder.vue";
import axios from "@/axios";
import ClientOrdersStatistic from "./OrderComponents/ClientOrderStatistic.vue";
import ShowProductAdditionalInfo from "./ProductComponents/ShowProductAdditionalInfo.vue";
import ClientCreateModal from "./ClientCreation/ClientCreationModal.vue";
import ProductsInSale from "./OrderComponents/ProductsInSale.vue";


export default {
  name: "table",
  components: {
    ProductsInSale,
    ClientCreateModal,
    ShowProductAdditionalInfo,
    ClientOrdersStatistic, ProductsInOrder, ClientLegalInfo, ClientPersonalInfo, CustomCheckBox
  },
  props: {
    isArenda: Boolean,
    columns: Array,
    data: Array,
    availableEdit: Boolean,
    isRepair: Boolean,
    clients: Array,
    products: Array,
    editAction: Function,
    deleteAction: Function,
    blockAction: Function,
    updateClients: Function,
    tableName: String,
    isDoc: Boolean,
    isBlock: Boolean,
    count: {
      type: Number,
      default: 0
    },
    summ: {
      type: Number,
      default: 0
    }
  },

  computed: {
    showPersonalModal: {
      get() {
        return this.$store.state.clientShowData;
      }
    },
    showLegalModal: {
      get() {
        return this.$store.state.clientLegalShowData;
      }
    },
    showProductsModal: {
      get() {
        return this.$store.state.orderProductsModal;
      }
    },
    showProductsInSale: {
      get() {
        return this.$store.state.productsInSales;
      }
    },
    isDocLoading: {
      get() {
        return this.$store.state.isDocLoading;
      }
    },
    clientOrdersStatisticModal: {
      get() {
        return this.$store.state.clientsOrdersModal;
      }
    },
    productAdditionalInfoModal: {
      get() {
        return this.$store.state.productAdditionalInfoModal;
      }
    }
  },
  methods:
      {

        getClientEntityById(id) {
          for (let i = 0; i < this.clients.length; i++) {
            ;
            if (this.clients[i].id == id) {
              return this.clients[i].isLegalEntity;
            }
          }
          return false;
        },

        setDocIsLoading(active) {
          this.$store.commit('updateIsDocLoading', active);
        },

        getActPriemPeredach(id) {
          const orderId = id;
          this.setDocIsLoading(true);
          axios
              .get(`/api/order/${orderId}/generate-act-priem-peredach`, {
                responseType: 'blob',
              })
              .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'act_priema_peredachi_' + orderId + '.docx');

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              })
              .catch((error) => {
                console.error('Error generating legal contract:', error);
              });
          this.setDocIsLoading(false);
        },

        saveLegalContract(id) {
          const orderId = id;
          this.setDocIsLoading(true);

          axios
              .get(`/api/order/${orderId}/generate-legal-contract`, {
                responseType: 'blob',
              })
              .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'legal_contract' + id + '.docx');

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              })
              .catch((error) => {
                console.error('Error generating legal contract:', error);
              });
          this.setDocIsLoading(false);
        },

        showDetails(data, name, key) {
          if (key == "personalData") {
            this.setClientPersonalData(data);
            this.setClientName(name);
            this.setClientShowData(true);
          } else if (key == "legalData") {
            this.setClientLegalData(data);
            this.setClientName(name);
            this.setClientShowLegalData(true);
          }
        },
        showProductsInOrder(data) {
          const client = this.getClientById(data.clientId);
          this.setClientInOrderInfo(client.fullName, client.personalData.phone);
          this.setViewOrderProductsData(data);
          this.setProductsInOrderModal(true);
        },
        showProductsInSales(data) {
          this.setViewOrderProductsData(data);
          this.setProductsInSales(true);
        },
        showClientOrders(data, client) {
          this.setClientOrders(data);
          this.setClientOrdersModal(true);
          this.$store.commit('updateClientOrderStatisticItem', client);
        },
        showProductAdditionalInfo(info) {
          this.$store.commit('updateProductAdditionalInfoModal', true);
          this.$store.commit('updateProductAdditionalInfo', info);
        },
        confirmDelete(item) {
          if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
            this.deleteAction(item);
          }
        },

//МОДАЛКА РЕДАКТИРОВАНИЯ КЛИЕНТА ИЗ ЗАКАЗА
    showEditModal(clientId) {
      this.setClientIsEditable(true);
      this.setClientData(this.getClientById(clientId));
      this.updateClientShowModal(true);
    },


    filteredData(item) {
      return item.filter(item => !('rentStartDate' in item));
    },
    setClientPersonalData(data) {
      this.$store.commit('updateClientPersonalData', data);
    },
    setClientShowData(active) {
      this.$store.commit('updateClientShowData', active);
    },
    setClientName(name) {
      this.$store.commit('updateCurrentClientName', name);
    },
    setClientLegalData(data) {
      this.$store.commit('updateClientLegalData', data);
    },
    setClientShowLegalData(active) {
      this.$store.commit('updateClientLegalShowData', active);
    },
    setViewOrderProductsData(data) {
      this.$store.commit('updateOrderViewProducts', data);
    },
    setProductsInOrderModal(active) {
      this.$store.commit('updateOrderViewModal', active);
    },
    setProductsInSales(active) {
      this.$store.commit('updateProductsInSale', active);
    },
    setClientData(clientData) {
      this.$store.commit('setEditClientData', clientData);
    },
    setClientOrders(orders) {
      this.$store.commit('updateClientOrders', orders);
    },
    setClientOrdersModal(active) {
      this.$store.commit('updateClientsOrdersModal', active);
    },
    setClientIsEditable(isEditable) {
      this.$store.commit('updateClientIsEditable', isEditable);
    },
    updateClientShowModal(active) {
      this.$store.commit('updateClientShowModal', active);
    },

    setClientInOrderInfo(name, phone){
      this.$store.commit('updateClientNameInOrder', name);
      this.$store.commit('updateClientPhoneInOrder', phone);
    },
    getClientNameById(id) {
      for (let i = 0; i < this.clients.length; i++) {
        if (this.clients[i].id == id) {
          return this.clients[i].fullName;
        }
      }
      return 'Клиент не найден';
    },
    getClientById(id) {
      for (let i = 0; i < this.clients.length; i++) {
        if (this.clients[i].id == id) {
          return this.clients[i];
        }
      }
      return null;
    },
    getTotalPrice(product) {
      const price = this.getProductPriceById(product.id);
      let totalPrice = product.count * price;
      if (product.discount !== 0) {
        totalPrice = totalPrice * (1 - product.discount / 100);
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getProductPriceById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].rentCost;
        }
      }
      return 0;
    },
    blockClient(id) {
      if (confirm("Вы уверены, что хотите внести клиента в черный список?")) {
        const reason = prompt("Пожалуйста, введите причину:");
        this.blockAction(id, reason);
      }
    },
    getStatusNameById(status) {
      if (status === 1) {
        return 'Бронь';
      } else if (status === 2) {
        return 'Активный';
      } else if (status === 3) {
        return 'Выполнен';
      }
    },
    getRowClass(item) {
      if ('qty' in item && Number(item.dostupno) <= 0) {
        return 'bg-red';
      } else if ('qty' in item && Number(item.dostupno) < 5) {
        return 'bg-yellow';
      } else if (item.status === 1) {
        return 'bg-blue';
      } else if (item.status === 2) {
        return 'bg-red';
      } else if (item.status === 3) {
        return 'bg-green';
      } else if (item.blackList != null) {
        return 'bg-red';
      }
      return '';
    },
    getItemClass(val) {
      if(val > 0)
        return 'red';
      else if (val < 0)
        return 'green';
      return 'black';
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }

  }
};
</script>

<style scoped>
.bg-blue {
  background-color: lightblue;
}

.bg-red {
  background-color: lightpink;
}

.bg-green {
  background-color: lightgreen; /* Зеленый цвет */
}

.bg-yellow {
  background-color: lightyellow;
}

.red{
  color: red;
  background-color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.black{
  color: black;
  background-color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.green{
  color: blue;
  background-color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
div {
  color: black;
  font-weight: 700;
}
.header-text {
  font-size: 10px !important;
}

</style>
